import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface Notification {
  id: number;
  type: 'success' | 'error' | 'info' | 'warning';
  message: string;
  duration?: number;
  closing: boolean;
}

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private notifications: Notification[] = [];
  private notificationSubject = new BehaviorSubject<Notification[]>([]);
  notification$ = this.notificationSubject.asObservable();
  private counter = 0;

  show(type: Notification['type'], message: string, duration: number = 6000) {
    const notification: Notification = {
      id: ++this.counter,
      type,
      message,
      duration,
      closing: false,
    };
    this.notifications.push(notification);
    this.notificationSubject.next([...this.notifications]);
    if (duration > 0) {
      setTimeout(() => this.startClosing(notification.id), duration - 300);
    }
  }
  dismiss(id: number) {
    this.notifications = this.notifications.filter((n) => n.id !== id);
    this.notificationSubject.next([...this.notifications]);
  }
  startClosing(id: number) {
    const list = this.notificationSubject.value.map((n) =>
      n.id === id ? { ...n, closing: true } : n
    );
    this.notificationSubject.next(list);
    setTimeout(() => this.dismiss(id), 300);
  }
}
